export const BASE_URL = 'https://api.themoviedb.org/3/movie/popular?api_key=fb030ab3fe4dfd1006bfff2534c26631&language=en-US&page=1';
export const SINGLE_MOVIE_URL = (id) => `https://api.themoviedb.org/3/movie/${id}?api_key=fb030ab3fe4dfd1006bfff2534c26631&language=en-US`;
export const apiImageAddress = 'https://image.tmdb.org/t/p/';

